import React from 'react'
import { Row as ReactstrapRow, RowProps } from 'reactstrap'

export const Row: React.FC<RowProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ReactstrapRow {...(props as any)} />
}
